"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplorerItemFactoryFromJs = exports.ExplorerItemFactory = void 0;
const immutable_1 = require("immutable");
exports.ExplorerItemFactory = (0, immutable_1.Record)({
    key: null,
    icon: null,
    text: null,
    type: null,
    dataRef: null,
    loaded: false,
    children: (0, immutable_1.List)()
});
const ExplorerItemFactoryFromJs = function (data) {
    const _items = data.children && data.children.length > 0
        ? data.children.map(function (value) {
            return (0, exports.ExplorerItemFactoryFromJs)(value);
        })
        : [];
    return (0, exports.ExplorerItemFactory)({
        key: data.key,
        icon: data.icon,
        text: data.text,
        type: data.type,
        dataRef: data.dataRef,
        loaded: data.loaded,
        children: (0, immutable_1.List)(_items)
    });
};
exports.ExplorerItemFactoryFromJs = ExplorerItemFactoryFromJs;
//# sourceMappingURL=IExplorerITem.js.map